import FieldEditor from "editor/FieldEditor";

class FieldEditorRadio extends FieldEditor {

    create() {
        this.settings = $.extend({default: false}, this.settings);

        const $input = this.$input = eotwJSXFactory('input', {class: this.settings.context === "admin-form" ? "admin-form__radio-checkbox" : "admin-editor admin-editor--radio", type: "radio"});

        if (this.settings.context === "admin-form") {
            this.$element.html(
                eotwJSXFactory('label', {class: "admin-form__label admin-form__label--smargin"}, [
                    $input,
                    this.settings.label
                ])
            );
        } else {
            this.$element.html($input);
        }

        if ("string" === typeof this.settings.name) {
            $input.attr("name", this.settings.name);
        }

        if ("object" === typeof this.settings.attributes) {
            $input.attr(this.settings.attributes);
        }

        this.$input.on("change", () => {
            this.emit("change", this.getValue());
        });

        this.$input.change();
    }

    destroy() {
        super.destroy();

        this.$element.text(this.getValue());
    }

    getValue() {
        return this.$input.is(":checked");
    }

    focus() {
        this.$input.focus();
    }

    setValue(value) {
        if ("undefined" === typeof value) {
            this.$input.prop("checked", this.settings.default);
        } else {
            this.$input.prop("checked", !!value);
        }
    }
}

FieldEditor.register_editor("radio", FieldEditorRadio);

export default FieldEditorRadio;
